import { render, staticRenderFns } from "./RecommendForYou.vue?vue&type=template&id=8964b69c&scoped=true"
import script from "./RecommendForYou.vue?vue&type=script&lang=js"
export * from "./RecommendForYou.vue?vue&type=script&lang=js"
import style0 from "./RecommendForYou.vue?vue&type=style&index=0&id=8964b69c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8964b69c",
  null
  
)

export default component.exports